import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
  SparePartCondition,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.sparePart}stockitem/bulkinsert`;

export interface BulkInsertStockItemOnStock {
  stockId: string;
  location?: string;
  sparePartSupplierAssociationId: string;
  condition: SparePartCondition;
  quantity: number;
}

export interface BulkInsertStockItemCommandArgs {
  stockItems: BulkInsertStockItemOnStock[];
}

async function bulkInsertStockItemCommand({
  stockItems,
}: BulkInsertStockItemCommandArgs): Promise<
  BaseBackResponse | BackResponseFailure
> {
  try {
    return await apiCall<BaseBackResponse>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        stockItems,
      },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default bulkInsertStockItemCommand;
